export enum MyCartActionButtonsEnum {
  PRODUCT_CARD = 'PRODUCT_CARD',
  INCREASE = 'INCREASE',
  DECREASE = 'DECREASE',
  SET_QUANTITY = 'SET_QUANTITY',
  MY_CART_DELETE = 'MY_CART_DELETE',
  TOOLTIP_DELETE = 'TOOLTIP_DELETE',
  TOOLTIP_ADD = 'TOOLTIP_ADD',
  CROSS_UPSELL = 'CROSS_UPSELL',
}

export enum FavoritesActionButtonsEnum {
  PRODUCT_CARD = 'PRODUCT_CARD',
  TOOLTIP_DELETE = 'TOOLTIP_DELETE',
  TOOLTIP_ADD = 'TOOLTIP_ADD',
}
